<template>
  <div>
    <section class="info accordion">
      <div class="px-4">
        <table class="noselect w-100 table table-hover bg-white">
          <template v-for="(stats, client_id) in statsClient">
            <div class="row float-left">
            </div>
            <tbody
              :key="client_id + 2"
              :id="'collapseLocation' + client_id"
              class=""
              :aria-labelledby="'collapseLocation' + client_id"
              data-parent="#accordionlocation"
            >
              <tr
                :key="client_id + 'header'"
                class="font-weight-bold"
                v-if="statsDate.length > 1 || thisMonth"
              >
                <td width="160px"></td>
                <td width="120px"
                  v-for="date in statsDate"
                  :key="client_id + date.date"
                  class="text-right"
                >
                  <b>{{ date.date }}</b>
                </td>
                <td class="text-right" v-if="statsDate.length > 1">Total</td>
              </tr>
              <template v-if="!onlyTotal">
                <tr v-for="(type, i) in statsType.filter(e => !e.includes('total'))" :key="type">
                  <td v-if="!thisMonth && statsTypeText.length === 0">
                    <b>{{ type }}</b>
                  </td>
                  <td v-else>
                    <b>{{ statsTypeText[i] }}</b>
                  </td>

                  <td
                    v-for="date in statsDate"
                    :key="client_id + type + date.date"
                    class="text-right"
                  >
                    <span
                      v-if="
                        stats[date.date] != undefined
                      "
                    >
                      <div v-if="thisMonth">
                        dd
                        <span class="small mr-2">{{ stats[date.date][type] }}
                          <span v-if="type != 'adjusted_comission'">%</span>
                          <span v-if="type == 'adjusted_comission'">€</span>
                        </span>
                        <span class="d-inline" v-if="type != 'adjusted_comission' && type != 'total_objective' ">({{ stats[date.date][type + "_amount"] }})</span>
                      </div>
                      <div v-else>
                        <span class="d-inline mr-1">€</span> <span class="d-inline">{{ getPrice(stats[date.date][type + "_amount"]) }}</span>
                      </div>
                    </span>
                    <span v-else>-</span>
                  </td>
                  <td
                    class="text-right font-weight-bold"
                    v-if="statsDate.length > 1"
                  >
                    <span class="d-inline mr-1">€</span> <span class="d-inline">{{ getPrice(stats[type + "_amount"]) }}</span>
                  </td>
                </tr>

              <tr class="font-weight-bold" v-if="statsDate.length > 1 && showTotal.subtotal">
                <td><b>{{ showSubtotal }}</b></td>
                <td
                  v-for="date in statsDate"
                  :key="client_id + date.date"
                  class="text-right"
                >
                  <span class="d-inline mr-1">€</span> <span class="d-inline">{{ getSubtotal(date.date, stats, showTotal.item) }}</span>
                </td>
                <td class="text-right">
                    <span class="d-inline mr-1">€</span> <span class="d-inline">{{ getFullTotal(stats) }}</span>
                </td>
              </tr>
              </template>
                <tr class="font-weight-bold" v-if="statsDate.length > 1 && showTotal.total">
                <td><b>{{ showDataTotal }}</b></td>

                <td
                  v-for="date in statsDate"
                  :key="client_id + date.date"
                  class="text-right"
                >
                  <!-- <span>
                    <span class="small" v-if="!onlyTotal"
                      >({{ getTotalQty(date.date, stats) }})</span
                    >
                  </span> -->
                  <span class="d-inline mr-1">€</span> <span v-if="showTotal.total" class="d-inline">{{ getTotalCustom(date.date, stats, showTotal.item) }}</span>
                </td>
                <!-- <td class="text-right">
                    <span class="d-inline small" v-if="!onlyTotal">{{ getFullTotalQty(stats) }}</span>
                    <span class="d-inline">{{ getFullTotal(stats) }}</span><span class="d-inline">€</span>
                </td> -->
              </tr>
            </tbody>
          </template>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { statusBadgeMixin, urlMixin, logoMixin } from "@/_mixins/";
import { billingsService, clientsService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
  props: {
    // stats: {
    //   type: Object,
    //   required: true,
    // },
    statsClient: {
      type: Object,
      required: true,
    },
    statsType: {
      type: Array,
      required: true,
    },
    statsDate: {
      type: Array,
      required: true,
    },
    onlyTotal: {
      type: Boolean,
      onlyTotal: false,
    },
    thisMonth: {
      type: Boolean,
      default: false,
    },
    statsTypeText:{
      type: Array,
      default: () => []
    },
    showTotal:{
      type: Object,
      default: () => {
        return { item: null, subtotal:false, total:false }
      }
    },
  },
  data() {
    return {
      fee:0.35,//antes 20% > ahora 35%
    };
  },

  components: {
    LoadingSpinner,
  },

  computed: {
    showSubtotal(){
      return this.statsTypeText.filter( e => e.includes('Sub-total'))[0]
    },
    showDataTotal(){
      return this.statsTypeText.filter( e => e.includes('Total'))[0]
    }
  },

  created() {
      if(this.hasPermissions('isReferal')){
        this.fee = 0.1
      }else{
        this.fee = 0.35
      }
    },


  methods: {
    getPrice(amount) {
      if(this.hasPermissions('isAgencyManager')){
        return parseFloat(amount*this.fee).toFixed(2)
      }
      return parseFloat(amount).toFixed(2);
    },
    getTotal(date, stats) {
      let total = 0;
      this.statsType.forEach((type) => {
        if (stats[date][type + "_amount"] != undefined) {
          total += parseFloat(stats[date][type + "_amount"]);
        }
      });
      if(this.hasPermissions('isAgencyManager')){
        return parseFloat(total*this.fee).toFixed(2)

      }
      return parseFloat(total).toFixed(2);
    },
    getTotalCustom( date, stats, item ){
      return stats[date]['total' + item ]
    },
     getSubtotal(date, stats, item) {
      return stats[date]['subtotal' + item ]
    },

    getTotalQty(date, stats) {
      let total = 0;
      this.statsType.forEach((type) => {
        if (stats[date][type] != undefined) {
          total += parseFloat(stats[date][type]);
        }
      });
      return parseFloat(total).toFixed(0);
    },
    getFullTotal(stats) {
      let total = 0;
      this.statsType.forEach((type) => {
        if(this.onlyTotal ){
          if (stats[type + "_amount"] != undefined && (type == 'subscription_charged' || type == 'charged' || type == 'charged_without_var' || type == 'subscription_charged_without_var')) {
            total += parseFloat(stats[type + "_amount"]);
          }
        }else{
          if (stats[type + "_amount"] != undefined) {
            total += parseFloat(stats[type + "_amount"]);
          }
        }
      });
      if(this.hasPermissions('isAgencyManager')){
        return parseFloat(total*this.fee).toFixed(2)
      }
      return parseFloat(total).toFixed(2);
    },
    getFullTotalQty(stats) {
      let total = 0;
      this.statsType.forEach((type) => {
        if (stats[type] != undefined) {
          total += parseFloat(stats[type]);
        }
      });
      return parseFloat(total).toFixed(0);
    },
    hasPermissions(perm){
      return this.$store.getters['authentication/hasPermissions'](perm)
    },
  },
};
</script>
<style>
</style>
